import React, { useEffect, useState } from 'react';
import {
  LocationDTO,
  UpdateLocationDTO,
} from '@peartherapeutics/weaver-api-client';
import InputGeneral from 'components/common/FormControls/FormInputs';
import { isValidPostalCode, validateName } from 'utils/validates';
import SelectState from './SelectState';
import './styles.scss';

export interface IRowProps {
  location: LocationDTO;
  onClickCancel: () => void;
  onSaveLocation: (data: UpdateLocationDTO) => void;
}

export const EditLocation = (props: IRowProps) => {
  const { location, onClickCancel, onSaveLocation } = props;
  const [state, setState] = useState<UpdateLocationDTO>(location);
  const [isInvalid, setInvalidity] = useState<string[]>([]);

  const onChangeField =
    (fieldName: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setState({ ...state, [fieldName]: event.target.value });
    };

  const handleSave = () => {
    onSaveLocation(state);
  };

  useEffect(() => {
    let invalidity = [];
    const { name, addressLine1, city, district, postalCode } = state;
    if (!isValidPostalCode(postalCode || '')) invalidity.push('postalCode');
    Object.entries({ name, addressLine1, city, district }).forEach(
      ([key, value]) => {
        if (!validateName(value || null)) invalidity.push(key);
      },
    );
    setInvalidity(invalidity);
  }, [state]);

  return (
    <tr styleName="table-row" data-testid="edit-location">
      <td style={{ width: 225, maxWidth: 225 }}>
        <InputGeneral
          error={isInvalid.includes('name')}
          helperText="Name is required."
          testidProp="row-input-name"
          autoFocus
          name="name"
          value={state.name}
          onChange={onChangeField('name')}
        />
      </td>
      <td style={{ width: 230, maxWidth: 230 }}>
        <InputGeneral
          error={isInvalid.includes('addressLine1')}
          helperText="Address is required."
          testidProp="row-input-address1"
          name="address1"
          value={state.addressLine1}
          onChange={onChangeField('addressLine1')}
        />
        <InputGeneral
          testidProp="row-input-address2"
          name="address2"
          value={state.addressLine2 || ''}
          onChange={onChangeField('addressLine2')}
        />
      </td>
      <td style={{ width: 120, maxWidth: 120 }}>
        <InputGeneral
          error={isInvalid.includes('city')}
          helperText="City is required."
          testidProp="row-input-city"
          name="city"
          value={state.city}
          onChange={onChangeField('city')}
        />
      </td>
      <td style={{ width: 100, maxWidth: 100 }}>
        <SelectState
          testidProp="row-input-district"
          selectedState={state.district || ''}
          onChange={onChangeField('district')}
        />
      </td>
      <td style={{ width: 100, maxWidth: 100 }}>
        <InputGeneral
          error={isInvalid.includes('postalCode')}
          helperText="ZIP is required."
          testidProp="row-input-postalCode"
          name="postalCode"
          value={state.postalCode}
          onChange={onChangeField('postalCode')}
        />
      </td>
      <td style={{ width: 115, maxWidth: 115 }}>
        <InputGeneral
          testidProp="row-input-external-ref"
          name="externalRef"
          value={state.externalRef}
          onChange={onChangeField('externalRef')}
        />
      </td>
      <td style={{ width: 200, maxWidth: 200 }} styleName="row-actions">
        <div>
          <button styleName="cancel" type="button" onClick={onClickCancel}>
            Cancel
          </button>
          <button
            disabled={!!isInvalid.length}
            styleName="save"
            type="button"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </td>
    </tr>
  );
};

export default EditLocation;
